<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment">
    <div class="ui basic segment" fxLayout="column" fxLayoutGap="25px">
      <div fxLayout="row">
        <div fxFlex>
          <img
            *ngIf="modal.context.data.photographDocumentPath"
            src="{{ baseUrl }}/public/image/?media={{
              modal.context.data?.photographDocumentPath
            }}"
            onerror="this.src='assets/avatar/1.jpg'"
            class="ui mini image"
          />
          <img
            *ngIf="!modal.context.data.photographDocumentPath"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Firstname</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.firstName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Lastname</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.lastName }}
        </div>
      </div>

      <div fxLayout="column" *ngIf="modal.context.data?.middleName">
        <div fxFlex>
          <div class="heading-text">Middlename</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.middleName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Email</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.email || "nil" }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Phone Number</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.phoneNumber || "nil" }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Gender</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.gender }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Nationality</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.nationalityName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Country of Origin</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.countryOfOriginName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">National ID Number</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.nationalIdNumber }}
        </div>
      </div>

      <div
        fxLayout="column"
        *ngIf="
          modal.context.data?.ownershipTypeIdName &&
          modal.context.data?.ownershipTypeIdName[0]?.shareholder_type ===
            'Shareholder'
        "
      >
        <div fxFlex>
          <div class="heading-text">Shareholding Amount</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ modal.context.data?.shareholding }}%
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <!-- <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done</button> -->
  </div>
</div>
